import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './styles.css';
import './design-v2.css';
import './design-v3.css';
import './design-v4.css';
import { startEnhancements } from './enhance';
import { applyTheme, loadTheme } from './theme';

applyTheme(loadTheme());

const root = document.getElementById('root')!;
createRoot(root).render(<StrictMode><App /></StrictMode>);
startEnhancements(root);
